import { useSelector } from 'react-redux';
import { systemOf } from '../constants/systems';
import { SWITCH_SLICES } from '../components/store/slices/switchSlices';

const NO_SLICE = Object.freeze({});

// One system's switch state: `tree` (zones with their sub-locations, as the
// zone list nests them) and `flat` (`[location][machine]`). Accepts 'ess' or
// DEVICE_TYPES.ESS. With no system (the master-control controllers render
// without one on the global page) both are undefined.
export const useSwitchState = (system) => {
  const { sliceKey, treeKey, flatKey } =
    system == null ? NO_SLICE : SWITCH_SLICES[systemOf(system).key];
  const tree = useSelector((state) => state[sliceKey]?.[treeKey]);
  const flat = useSelector((state) => state[sliceKey]?.[flatKey]);
  return { tree, flat };
};
